import * as React from 'react';
import { useContext } from 'react';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import clsx from 'clsx';

import { ArrowUpIcon, ArrowDownIcon, AvatarIcon } from 'components/common/Icons/Icons';
import Button from 'components/common/Button/Button';
import { ApplicationRoute } from 'routes/routes.enums';
import { RootStoreContext } from 'index';
import { getFirstNameWithInitial } from 'common/utils/string.utils';

import { useBurgersMenu } from './useBurgersMenu';
import styles from './BurgersMenu.module.scss';

interface AccountMenuProps {
  handleLogout: () => void;
}

const AccountMenu = ({ handleLogout }: AccountMenuProps) => {
  const { anchorEl, isMenuOpen, handleClick, handleClose, goTo } = useBurgersMenu();
  const { authStore } = useContext(RootStoreContext);

  return (
    <React.Fragment>
      <Button
        className={styles.button}
        onClick={handleClick}
        variant="underline"
        aria-controls={isMenuOpen ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={isMenuOpen ? 'true' : undefined}
      >
        <AvatarIcon className={styles.icon} />
        {getFirstNameWithInitial(authStore.account!.firstName, authStore.account!.lastName)}
        {isMenuOpen ? (
          <ArrowUpIcon className={clsx(styles.arrowIcon, styles.arrowOpenIcon)} />
        ) : (
          <ArrowDownIcon className={styles.arrowIcon} />
        )}
      </Button>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={isMenuOpen}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={goTo(ApplicationRoute.MyProfile)} className={styles.menuItem}>
          My Profile
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleLogout} className={styles.signOut}>
          Sign out
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
};

export default AccountMenu;
